import gql from 'graphql-tag';

export const TOGGLE_TERRITORY_WORKFLOW_STATUS = gql`
  mutation ToggleTerritoryWorkflowStatus($deploymentModelId: Int!) {
    toggleTerritoryWorkflowStatus(deploymentModelId: $deploymentModelId) {
      isTerritoryWorkflowStarted
    }
  }
`;
